/**
 * 유틸리티 관련 서비스
 */
import carbonApi from "../api";
import { unwrapResponse } from "../utils/api.js";

/**
 * 시설 조회
 * @param {string} facilityCode - 시설 코드
 * @returns {Promise<Object>} 시설 정보
 */
export async function fetchFacility(facilityCode) {
    const response = await carbonApi.utility.getFacilities(facilityCode);
    return unwrapResponse(response, { defaultMessage: "시설 조회에 실패했습니다." });
}
